export default "__VITE_ASSET__a8367511__"